<div class="container">
  <div class="video-inner-container">
    <ng-container brComponent="video-content"></ng-container>
  </div>
</div>

<!--modified for RWD-->
